<template>
  <div>
    <router-link :to="{ name: 'spcoreBrandSummary' }">SPCore</router-link>
    <router-link :to="{ name: 'acticsLandingPage' }">Actics</router-link>
    <router-link :to="{ name: 'acticsLogIn' }">Login</router-link>
    <router-link :to="{ name: 'cohorts' }">Cohorts</router-link>
    <router-link :to="{ name: 'medInsights' }">MedInsingths</router-link>
    <router-link :to="{ name: 'enterpriseMetrics' }">Enterprise Metrics</router-link>
    <router-link :to="{ name: 'itOperations' }">IT Operations</router-link>
    <router-link :to="{ name: 'callPlanning' }">Call Planning</router-link>
    <router-link :to="{ name: 'itmOrders' }">ITM</router-link>
    <router-link :to="{ name: 'test' }">Test</router-link>
  </div>
</template>

<script>
export default {
  noExport: true,
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisHome'] = this;
  },
}
</script>

<style lang="scss" scoped>
div a {
  margin-right: 10px;
  font-size: 16px;
}
</style>